window.addEventListener('load', function() {
	document.querySelector('#app').classList.remove('loading')
})
